!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? a(exports, require("@material-ui/pickers"), require("formik"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "@material-ui/pickers", "formik", "react"], a) : a((e = e || self)["date-picker"] = {}, e.pickers, e.formik, e.React);
}(this, function (e, a, t, r) {
  "use strict";

  var n = "default" in r ? r.default : r,
      _i = function i() {
    return (_i = Object.assign || function (e) {
      for (var a, t = 1, r = arguments.length; t < r; t++) for (var n in a = arguments[t]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);

      return e;
    }).apply(this, arguments);
  };

  function o(e, a) {
    var t = {};

    for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && a.indexOf(r) < 0 && (t[r] = e[r]);

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var n = 0;

      for (r = Object.getOwnPropertySymbols(e); n < r.length; n++) a.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
    }

    return t;
  }

  var l = function l(e, a) {
    return e.weekdayLong.toLowerCase() !== a.toLowerCase();
  },
      d = function d(e) {
    var d = e.form,
        u = e.field,
        c = e.keyboard,
        f = e.handleChange,
        y = e.allowedDay,
        s = e.inputVariant,
        m = e.staticMode,
        p = e.validationError,
        v = e.validate,
        h = o(e, ["form", "field", "keyboard", "handleChange", "allowedDay", "inputVariant", "staticMode", "validationError", "validate"]),
        b = t.getIn(d.errors, u.name),
        k = d.touched[u.name],
        g = r.useState(),
        D = g[0],
        E = g[1];
    r.useEffect(function () {
      v && E(v);
    }, [v]), r.useEffect(function () {
      E(p);
    }, [p]), r.useEffect(function () {
      k && !p && E(b);
    }, [b, k]);

    var O = function O(e) {
      f && f(e && e.isValid ? e.toJSDate() : void 0), e && e.isValid ? d.setFieldValue(u.name, e.toJSDate(), !0) : d.setFieldValue(u.name, void 0);
    };

    return !1 === c ? n.createElement(a.DatePicker, _i({
      name: u.name,
      value: u.value,
      onChange: O,
      format: "dd/MM/yyyy",
      placeholder: "dd/mm/yyyy",
      shouldDisableDate: y ? function (e) {
        return l(e, y);
      } : void 0,
      error: !!D,
      helperText: D && D,
      inputVariant: s,
      variant: m ? "static" : "dialog",
      onBlur: function onBlur() {
        return d.setFieldTouched(u.name, !0);
      }
    }, h)) : n.createElement(a.KeyboardDatePicker, _i({
      name: u.name,
      value: u.value,
      onChange: O,
      format: "dd/MM/yyyy",
      placeholder: "dd/mm/yyyy",
      shouldDisableDate: y ? function (e) {
        return l(e, y);
      } : void 0,
      error: !!D,
      helperText: D && D,
      inputVariant: s,
      onBlur: function onBlur() {
        return d.setFieldTouched(u.name, !0);
      }
    }, h));
  };

  e.DatePickerField = function (e) {
    var a = e.name,
        r = e.keyboard,
        l = e.allowedDay,
        u = e.handleChange,
        c = e.inputVariant,
        f = e.staticMode,
        y = e.validationError,
        s = e.validate,
        m = o(e, ["name", "keyboard", "allowedDay", "handleChange", "inputVariant", "staticMode", "validationError", "validate"]);
    return n.createElement(t.Field, {
      name: a,
      validate: s
    }, function (e) {
      var a = e.field,
          t = e.form,
          o = e.meta;
      return n.createElement(d, _i({
        field: a,
        form: t,
        meta: o,
        keyboard: r,
        allowedDay: l,
        handleChange: u,
        inputVariant: c || "filled",
        staticMode: f,
        validationError: y,
        validate: s
      }, m));
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});